import { Component } from '@angular/core';
import { PipesModule } from '@app/pipes/pipes.module';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-support',
  imports: [PipesModule],
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: true,
})
export class SupportComponent {
  supportUrl = environment.support_url;

  constructor() {}
}
